import { IntlShape, useIntl } from 'react-intl';
import formMessages from '~/components/form-messages';
import { z } from 'zod';
import { Stack } from '@mui/system';
import messages from './messages';
import { useAppForm } from '../Form';

const createOnSubmitSchema = (intl: IntlShape) =>
  z.object({
    file: z.file(intl.formatMessage(formMessages.required)),
  });

type FormValues = z.infer<ReturnType<typeof createOnSubmitSchema>>;

const createOnChangeSchema = (intl: IntlShape) => {
  const onSubmitSchema = createOnSubmitSchema(intl);
  return onSubmitSchema.extend({
    file: onSubmitSchema.shape.file.nullable(),
  });
};

type DocumentFormProps = {
  onSubmit: (values: FormValues) => void;
};

export const DocumentForm = (props: DocumentFormProps) => {
  const intl = useIntl();
  const form = useAppForm({
    defaultValues: {
      file: null as File | null,
    },
    onSubmit: ({ value }) => {
      if (!value.file) {
        return;
      }
      props.onSubmit({
        file: value.file,
      });
    },
    validators: {
      onChange: createOnChangeSchema(intl),
      onSubmit: createOnSubmitSchema(intl),
    },
  });
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
    >
      <Stack spacing={2}>
        <div>
          <form.AppField name="file">
            {(field) => (
              <field.FileField label={intl.formatMessage(messages.file)} />
            )}
          </form.AppField>
        </div>
        <div>
          <form.AppForm>
            <form.SubmitButton />
          </form.AppForm>
        </div>
      </Stack>
    </form>
  );
};

export default DocumentForm;
